var _filter, _filter2, _linearGradient, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVscode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 236.149,
    width: 298.822,
    x: -21.49,
    y: 40.523
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "overlay",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 297.347,
    width: 122.667,
    x: 154.667,
    y: -20.674
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "overlay",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    mode: "normal",
    result: "shape"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 127.844,
    x2: 127.844,
    y1: 0.66,
    y2: 255.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    height: 256,
    maskUnits: "userSpaceOnUse",
    width: 256,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m181.534 254.252c4.032 1.571 8.63 1.47 12.7-.488l52.706-25.361c5.538-2.665 9.06-8.271 9.06-14.42v-171.9649c0-6.1492-3.522-11.7543-9.06-14.4193l-52.706-25.36199c-5.341-2.569942-11.592-1.940466-16.279 1.46737-.67.48682-1.308 1.03036-1.906 1.62936l-100.9 92.05266-43.9498-33.3615c-4.0913-3.1056-9.8139-2.8512-13.6137.6053l-14.09614 12.8225c-4.64789 4.228-4.65322 11.5401-.01151 15.7749l38.11475 34.7726-38.11475 34.773c-4.64171 4.235-4.63638 11.547.01151 15.775l14.09614 12.822c3.7998 3.457 9.5224 3.711 13.6137.606l43.9498-33.362 100.9 92.053c1.596 1.597 3.47 2.8 5.485 3.585zm10.505-184.3667-76.56 58.1147 76.56 58.115z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.94 27.6383-52.747-25.39692c-6.105-2.939682-13.402-1.699659-18.194 3.09194l-172.67529 157.43968c-4.64453 4.235-4.63919 11.547.01152 15.775l14.10467 12.822c3.8022 3.457 9.5283 3.711 13.622.606l207.9411-157.7491c6.976-5.2922 16.996-.3166 16.996 8.4398v-.6124c0-6.1465-3.521-11.7496-9.059-14.416z",
    fill: "#0065a9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.94 228.362-52.747 25.397c-6.105 2.939-13.402 1.699-18.194-3.092l-172.67529-157.4398c-4.64453-4.2347-4.63919-11.547.01152-15.7749l14.10467-12.8225c3.8022-3.4565 9.5283-3.711 13.622-.6053l207.9411 157.7485c6.976 5.292 16.996.317 16.996-8.44v.613c0 6.146-3.521 11.749-9.059 14.416z",
    fill: "#007acc"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m194.196 253.763c-6.107 2.937-13.404 1.696-18.196-3.096 5.904 5.904 16 1.722 16-6.628v-232.0784c0-8.35003-10.096-12.531775-16-6.62739 4.792-4.792044 12.089-6.033817 18.196-3.09673l52.738 25.36202c5.542 2.665 9.066 8.2701 9.066 14.4193v171.9652c0 6.149-3.524 11.754-9.066 14.419z",
    fill: "#1f9cf0"
  })), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m181.378 254.252c4.032 1.57 8.63 1.47 12.699-.488l52.706-25.362c5.539-2.665 9.061-8.27 9.061-14.419v-171.9651c0-6.1492-3.522-11.7543-9.06-14.4193l-52.707-25.36195c-5.34-2.569949-11.591-1.940473-16.279 1.46736-.669.48682-1.307 1.03036-1.906 1.62936l-100.8993 92.05263-43.9498-33.3615c-4.0912-3.1056-9.8139-2.8511-13.6137.6053l-14.09609 12.8225c-4.64789 4.228-4.65322 11.5402-.01151 15.775l38.1148 34.7727-38.1148 34.773c-4.64171 4.235-4.63638 11.547.01151 15.775l14.09609 12.822c3.7998 3.457 9.5225 3.711 13.6137.606l43.9498-33.362 100.8993 92.053c1.596 1.597 3.471 2.8 5.486 3.585zm10.505-184.3669-76.56 58.1149 76.56 58.115z",
    fill: "url(#c)",
    fillRule: "evenodd",
    opacity: 0.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.e095357983cecdfb9217f7ebe8785a9b.svg";
export { ForwardRef as ReactComponent };